import React from 'react'
import DocumentTitle from 'react-document-title'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import SearchFields from './fields'

/**
 * Text search page
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class TextSearch extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    metro: React.PropTypes.object.isRequired,
    query: React.PropTypes.object,
    savedSearches: React.PropTypes.object.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object,
    router: React.PropTypes.func
  }

  static fetchData (store, { params }) {
    return {
      metro: store.get('/account/metro'),
      savedSearches: store.get('/searches')
    }
  }

  constructor(props, context) {
    super(props, context)

    const { store } = context

    if (!props.query.refine) {
      delete store.storage.lastSearch
    }

    if (props.query.myRecords) {
      store.storage.lastSearch = '{ "transaction": { "type": "Sale", "isPrivate": true } }'
    }

    delete store.storage.searchIds
    delete store.storage.lastSearchResult
    store.delete('~/search/lastResult')
  }

  handleSubmit (search) {
    this.context.router.transitionTo('results', null, search.toJS())
  }

  render() {
    const { account, metro, savedSearches } = this.props
    const { metadata } = this.context.store

    return (
      <DocumentTitle title="Search">
        <div>
          <SearchFields
            savedSearches={savedSearches.get('data')}
            account={account}
            metro={metro}
            metadata={metadata}
            onSubmit={::this.handleSubmit} />
        </div>
      </DocumentTitle>
    )
  }
}

export default TextSearch



// WEBPACK FOOTER //
// ./modules/shared/pages/search/textSearch.js